export default "__VITE_ASSET__BURIzANy__"